import React, { useMemo } from 'react'
import { LocalStorageService } from '../../services/LocalStorageService';
import { STORAGE } from '../../constants';
import { useTranslation } from 'react-i18next';

export default function GreetingPage() {
    const session = useMemo(() => LocalStorageService.get(STORAGE.SESSION), []);
    const { t } = useTranslation();
    return (
        <div className='col container-fluid d-flex justify-content-center align-items-center border bg-light ' style={{ height: 'auto' }}>
            <div className='col-md-6 p-4 rounded text-center'>
                <span className="avatar avatar-lg avatar-primary avatar-circle">
                    <span className="avatar-initials">{(session.name || session.user_name)[0]}</span>
                </span>
                <h3 className='mt-2'>{`${t("follow-up.initial.greeting")} ${(session.name || session.user_name)}!`}</h3>
                <p>{t("follow-up.initial.initial-text")}</p>
            </div>
        </div>
    )
}
